// extracted by mini-css-extract-plugin
export var readonly = "_c6-1";
export var star = "_c6-0";